var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascotte10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#F4EFFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480.606 63.1739C544.511 59.902 564.912 104.122 665.725 85.7497C746.112 71.1018 780.719 125.792 790.73 159.769C795.507 176.002 796.721 239.451 752.609 240.357C602.906 243.478 482.957 407.926 410.785 264.116C381.512 205.776 335.529 70.6236 480.606 63.1739Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M-141.394 -87.8261C-77.4885 -91.098 -57.0883 -46.8776 43.7247 -65.2503C124.112 -79.8982 158.719 -25.2079 168.73 8.76903C173.507 25.0025 174.721 88.4512 130.609 89.3573C-19.0939 92.4781 -139.043 256.926 -211.215 113.116C-240.488 54.7763 -286.471 -80.3764 -141.394 -87.8261Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 37,
    width: 370,
    height: 140,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.975 333.794C241.79 361.487 266.446 392.471 297.107 392.679C327.779 392.887 352.85 362.249 353.035 334.545C353.22 306.852 328.46 292.578 297.788 292.37C267.116 292.163 242.16 306.09 241.963 333.783L241.975 333.794Z",
    fill: "url(#paint0_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.441 306.262L337.431 306.267C331.667 309.143 329.325 316.147 332.2 321.911L346.37 350.319C349.245 356.084 356.249 358.426 362.013 355.551L362.024 355.545C367.788 352.67 370.13 345.666 367.255 339.902L353.085 311.494C350.21 305.729 343.206 303.387 337.441 306.262Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.566 289.475L219.556 289.481C214.189 293.044 212.727 300.283 216.29 305.65L238.461 339.045C242.024 344.411 249.262 345.873 254.629 342.311L254.639 342.304C260.006 338.741 261.468 331.502 257.905 326.136L235.734 292.741C232.171 287.374 224.932 285.912 219.566 289.475Z",
    fill: "url(#paint2_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.249 222.55L242.737 211.279C237.078 207.826 229.964 207.802 224.282 211.221C214.686 216.972 207.468 225.968 203.934 236.581C198.068 254.169 205.921 273.397 222.412 281.85L240.75 291.25L261.237 222.55H261.249Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.784 232.978L242.39 223.613C237.678 220.749 231.765 220.726 227.042 223.566C219.074 228.347 213.069 235.831 210.135 244.642C205.262 259.262 211.787 275.245 225.506 282.278L240.75 290.096L257.784 232.978Z",
    fill: "url(#paint3_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.572 222.55L344.084 211.279C349.743 207.826 356.857 207.802 362.538 211.221C372.123 216.972 379.341 225.968 382.875 236.569C388.741 254.157 380.889 273.385 364.398 281.839L346.059 291.239L325.572 222.538V222.55Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.037 232.978L344.431 223.613C349.143 220.749 355.055 220.726 359.779 223.566C367.747 228.347 373.752 235.831 376.685 244.642C381.559 259.262 375.034 275.245 361.315 282.278L346.071 290.096L329.037 232.978Z",
    fill: "url(#paint4_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.193 277.139C355.193 311.264 327.535 326.566 293.41 326.566C259.285 326.566 231.626 311.264 231.626 277.139C231.626 243.014 269.713 206.371 293.41 206.371C317.107 206.371 355.193 243.014 355.193 277.139Z",
    fill: "url(#paint5_linear_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.257 210.771C285.708 214.951 285.8 227.123 285.8 227.123C285.927 227.539 286.516 227.4 286.712 227.273C287.555 226.73 289.495 224.363 289.495 224.363C289.738 224.017 290.258 224.097 290.396 224.49C290.396 224.49 291.678 228.902 291.967 232.863C291.99 233.117 292.752 232.978 292.948 232.839C294.785 231.511 296.332 224.224 296.332 224.224C296.447 223.82 296.956 223.716 297.221 224.028C297.221 224.028 299.3 224.975 300.385 227.816C300.466 228.035 301.113 227.747 301.286 227.585C304.739 224.421 306.841 212.434 304.254 208.704C300.582 203.403 275.199 206.879 280.257 210.759V210.771Z",
    fill: "#8058EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.804 264.113C309.867 258.05 319.683 258.05 325.745 264.113",
    stroke: "#474193",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.841 293.769L312.88 293.48C321.438 291.136 329.071 286.227 334.753 279.414C336.058 277.855 338.552 278.317 339.21 280.234C341.37 286.505 342.987 296.482 335.492 301.956C324.14 310.26 314.462 302.106 310.605 298.041C309.254 296.621 309.935 294.277 311.829 293.757L311.841 293.769Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.609 284.83C279.495 284.83 287.509 274.489 287.509 261.733C287.509 248.977 279.495 238.637 269.609 238.637C259.723 238.637 251.709 248.977 251.709 261.733C251.709 274.489 259.723 284.83 269.609 284.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.312 259.931C282.312 255.467 278.693 251.848 274.228 251.848C269.764 251.848 266.145 255.467 266.145 259.931V268.015C266.145 272.48 269.764 276.099 274.228 276.099C278.693 276.099 282.312 272.48 282.312 268.015V259.931Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.496 263.396C274.728 263.396 276.538 261.587 276.538 259.354C276.538 257.122 274.728 255.312 272.496 255.312C270.264 255.312 268.454 257.122 268.454 259.354C268.454 261.587 270.264 263.396 272.496 263.396Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.209 299.854L234.594 297.256C235.645 295.293 238.232 294.531 240.034 295.847C240.161 295.94 243.775 302.649 246.42 304.659C249.33 306.864 255.093 307.13 260.162 302.268C266.883 295.824 267.692 285.685 272.288 281.631C280.36 274.506 290.095 275.684 296.84 281.539C303.584 287.394 304.97 298.249 300.189 305.86C295.431 313.447 278.605 322.454 270.025 324.903C259.492 327.905 248.995 323.067 244.387 319.533C237.019 313.909 232.135 305.248 232.135 305.248C230.079 303.238 231.476 301.079 233.22 299.854H233.209Z",
    fill: "url(#paint6_linear_0_1)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261 202L234 177H256.909L261 202Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 78,
    y: 22,
    width: 430,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 233.963,
    y: 287.368,
    width: 127.073,
    height: 116.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 223.626,
    y: 201.371,
    width: 139.567,
    height: 136.194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 277.593,
    y: 205,
    width: 29.8149,
    height: 31.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_1",
    x: 223.112,
    y: 271.709,
    width: 87.9058,
    height: 65.1348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 297.51,
    y1: 292.383,
    x2: 297.508,
    y2: 392.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 349.724,
    y1: 305.037,
    x2: 349.724,
    y2: 356.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 239.107,
    y1: 313.414,
    x2: 256.737,
    y2: 278.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 257.784,
    y1: 255.775,
    x2: 208.53,
    y2: 255.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 329.037,
    y1: 255.775,
    x2: 378.291,
    y2: 255.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 293.41,
    y1: 326.566,
    x2: 293.41,
    y2: 206.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 297.573,
    y1: 281.935,
    x2: 241.844,
    y2: 319.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotte10);
export default __webpack_public_path__ + "static/media/mascotte10.363881b420aeabf0de4aea571761ee6b.svg";
export { ForwardRef as ReactComponent };